import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  section: css`
    display: flex;
    padding: 0px 16px 0px 16px;
    flex-direction: column;
    h3 {
      padding-top: 16px;
    }
  `,
  orgName: css`
    font-size: 20px;
    color: ${colors.prussian};
    font-family: 'Proxima Nova Bold', Arial, Helvetica, sans-serif;
  `,
  description: css`
    color: ${colors.prussian};
    font-size: 14px;
    padding-bottom: 8px;
    padding-top: 8px;
  `,
  infoContainer: css`
    padding-bottom: 32px;
  `,
  info: css`
    display: flex;
    align-items: flex-start;
    color: ${colors.prussian};
    padding-top: 27px;
  `,
  infoText: css`
    font-size: 14px;
    padding-left: 19px;
    color: ${colors.prussian};
    font-family: 'Proxima Nova';
    text-decoration: none;
  `,
  link: css`
    color: ${colors.jungle};
    text-decoration: underline;
  `,
  flyersContainer: css`
    padding: 16px 0px 32px;
  `,
  buttonFollow: css`
    &.MuiButton-root {
      color: ${colors.white};
      background-color: ${colors.jungle} !important;
      text-transform: capitalize;
      padding: 4px 16px;
      border-radius: 8px;
      box-shadow: none;
      font-family: 'Proxima Nova';
      max-height: 32px;
    }
  `,
  divisor: css`
    padding: 0px 16px 0px 16px;
  `,
  orgNameTitle: css`
    display: flex;
    justify-content: space-between;
  `,
  sectionTitle: css`
    position: sticky;
    z-index: 1;
    transition: top 0.2s ease-out;
    background: ${colors.white};
  `,
};

export default styles;
